import { defineConfig } from '@stackflow/config';

export const config = defineConfig({
    transitionDuration: 350,
    activities: [
        { name: 'MainActivity', route: '/' },
        { name: 'NotOperationModal', route: '/not-operation' },
        { name: 'ItemSoldOutModal', route: 'item-sold-out' },
        { name: 'NotificationActivity', route: '/notifications' },
        { name: 'SignInActivity', route: '/auth/sign-in' },
        { name: 'SignInWithPhoneActivity', route: '/auth/sign-in/phone' },
        { name: 'SignInWithKakaoActivity', route: '/auth/sign-in/kakao' },
        { name: 'SignInWithAppleActivity', route: '/auth/sign-in/apple' },
        { name: 'SignInWithGoogleActivity', route: '/auth/sign-in/google' },
        { name: 'SignUpActivity', route: '/auth/sign-up' },
        { name: 'IdentifySuccessActivity', route: '/identity/done' },
        { name: 'IdentifyFailActivity', route: '/errors/identity-failed' },
        { name: 'TermDetailActivity', route: '/terms' },
        { name: 'TermSelectBottomSheet', route: '/terms/select' },
        { name: 'BoardActivity', route: '/boards' },
        { name: 'EventActivity', route: '/events/:eventId' },
        { name: 'NoticeActivity', route: '/notices/:noticeId' },
        { name: 'ShopListActivity', route: '/shops' },
        { name: 'ShopLocationBottomSheet', route: '/shops/location' },
        { name: 'ShopPrepareModal', route: '/shops/prepare' },
        { name: 'ShopDetailBottomSheet', route: '/shops/:shopId' },
        { name: 'ItemsActivity', route: '/shops/:shopId/items' },
        { name: 'ItemFilterBottomSheet', route: '/items/filter' },
        { name: 'ItemActivity', route: '/shops/:shopId/items/:itemId' },
        { name: 'ItemNutritionModal', route: '/shops/items/:itemId/nutrition' },
        { name: 'PersonalOptionActivity', route: '/items/:itemId/personal-options' },
        { name: 'OrderActivity', route: '/orders' },
        { name: 'OrderCouponActivity', route: '/orders/coupons' },
        { name: 'ItemCouponTargetBottomSheet', route: '/orders/coupons/target' },
        { name: 'OrderGiftBottomSheet', route: '/orders/gifts' },
        { name: 'OrderPrepaidCardBottomSheet', route: '/orders/prepaid-cards' },
        { name: 'OrderPaymentMethodBottomSheet', route: '/orders/payment-methods' },
        { name: 'OrderEasyCardBottomSheet', route: '/orders/easy-cards' },
        { name: 'OrderEasyCardPinActivity', route: '/orders/easy-cards/pin' },
        { name: 'FingerPayActivity', route: '/orders/finger-pay' },
        { name: 'OrderLogsActivity', route: '/orders/logs' },
        { name: 'OrderLogActivity', route: '/orders/logs/:orderNo' },
        { name: 'OrderReceiptActivity', route: '/orders/logs/:orderId/receipt' },
        { name: 'CancelOrderModal', route: '/orders/logs/:orderNo/cancel' },
        { name: 'OrderCompleteActivity', route: '/order/done' },
        { name: 'TossOrderFailActivity', route: '/order/toss/fail' },
        { name: 'TossOrderSuccessActivity', route: '/order/toss/success' },
        { name: 'CustomerServiceActivity', route: '/customer-service' },
        { name: 'InquiryActivity', route: '/customer-service/inquiry' },
        { name: 'InquiryLogActivity', route: '/customer-service/inquiry/logs/:inquiryId' },
        { name: 'CloseInquiryModal', route: '/customer-service/inquiry/logs/:inquiryId/close' },
        { name: 'InquiryCommentModal', route: '/customer-service/inquiry/logs/:inquiryId/comment/confirm' },
        { name: 'InquiryCommentBottomSheet', route: '/customer-service/inquiry/logs/:inquiryId/comment' },
        { name: 'InquiryTypeBottomSheet', route: '/customer-service/inquiry/type' },
        { name: 'ProjectActivity', route: '/project' },
        { name: 'AccountSettingActivity', route: '/account' },
        { name: 'AccountTerminationActivity', route: '/account/termination' },
        { name: 'NickNameChangeModal', route: '/account/nickname-changed' },
        { name: 'LogoutModal', route: '/account/logout' },
        { name: 'GiftsActivity', route: '/gifts' },
        { name: 'GiftItemActivity', route: '/gift-items/:giftItemId' },
        { name: 'GiftMenuDetailActivity', route: '/gift-items/:giftItemId/menu-detail' },
        { name: 'GiftSentActivity', route: '/gifts/send/:giftOrderNo' },
        { name: 'GiftReceivedActivity', route: '/gifts/received/:giftBoxItemId' },
        { name: 'GiftUsageActivity', route: '/gifts/coupons/:giftCouponId/usages' },
        { name: 'GiftOrderActivity', route: '/gifts/order' },
        { name: 'GiftAddContactActivity', route: '/gifts/order/contacts/new' },
        { name: 'GiftOrderCompleteActivity', route: '/gifts/order/complete' },
        { name: 'GiftCancelModal', route: '/gifts/cancel/:giftBoxItemId' },
        { name: 'GiftCanceledModal', route: '/gifts/canceled' },
        { name: 'RegisterGiftActivity', route: '/register-gift' },
        { name: 'DeleteGiftModal', route: '/gifts/coupons/:giftCouponId/delete' },
        { name: 'CancelPaymentModal', route: '/gifts/orders/:giftOrderId/cancel' },
        { name: 'ContactMethodBottomSheet', route: '/gifts/order/contacts/method' },
        { name: 'MyPrepaidCardActivity', route: '/prepaid-cards/my' },
        { name: 'PrepaidCardImagesActivity', route: '/prepaid-cards/images' },
        { name: 'PrepaidCardImageActivity', route: '/prepaid-cards/images/:prepaidCardImageId' },
        { name: 'CardManageBottomSheet', route: '/prepaid-cards/:prepaidCardId/manage' },
        { name: 'UpdateCardNameBottomSheet', route: '/prepaid-cards/:prepaidCardId/name' },
        { name: 'PrepaidCardBarcodeBottomSheet', route: '/prepaid-cards/:prepaidCardId/barcode' },
        { name: 'PrepaidCardChargeActivity', route: '/prepaid-cards/:prepaidCardId/charge' },
        { name: 'PrepaidCardTransferActivity', route: '/prepaid-cards/:prepaidCardId/transfer' },
        { name: 'PrepaidCardOrderCompleteActivity', route: '/prepaid-cards/order/complete' },
        { name: 'PrepaidCardLogActivity', route: '/prepaid-cards/:prepaidCardId/logs' },
        { name: 'PrepaidCardGiftDetailActivity', route: '/prepaid-cards/gift-box/:giftBoxId' },
        { name: 'DeleteCardModal', route: '/prepaid-cards/:prepaidCardId/delete' },
        { name: 'TransferConfirmModal', route: '/prepaid-cards/:prepaidCardId/transfer/:targetCardId' },
        { name: 'CancelChargeModal', route: '/prepaid-cards/orders/:orderNo/cancel' },
        { name: 'PrepaidCardChargeCompleteActivity', route: '/prepaid-cards/charge/complete' },
        { name: 'MyMenuActivity', route: '/my-menu' },
        { name: 'MyMenuSettingBottomSheet', route: '/my-menu/setting' },
        { name: 'PointActivity', route: '/points' },
        { name: 'StampsActivity', route: '/stamps' },
        { name: 'StampScopeBottomSheet', route: '/stamps/select-scope' },
        { name: 'StampSortBottomSheet', route: '/stamps/sort' },
        { name: 'CartActivity', route: '/cart/:shopId' },
        { name: 'BarcodeModal', route: '/barcode' },
        { name: 'CouponActivity', route: '/coupons' },
        { name: 'CouponSortBottomSheet', route: '/coupons/sort' },
        { name: 'CouponDetailActivity', route: '/coupons/:couponId' },
        { name: 'ExternalShopModal', route: '/external-shop' },
        { name: 'UserPaymentCancelActivity', route: '/errors/user-cancel' },
        { name: 'PaymentFailedActivity', route: '/errors/payment-failed' },
        { name: 'AlertActivity', route: '/alert' },
        { name: 'GpsPermissionModal', route: '/gps-permission' },
        { name: 'DeleteAllMyMenuModal', route: '/my-menu/delete-all' },
        { name: 'SinglePurchaseModal', route: '/my-menu/single-purchase' },
        { name: 'PermissionBottomSheet', route: '/permissions' },
        { name: 'LinkActivity', route: '/link' },
        { name: 'TestActivity', route: '/test' },
        { name: 'AppTerminationModal', route: '/app-termination' },
        { name: 'ForceUpdateModal', route: '/force-update' },
        { name: 'AttendanceCheckActivity', route: '/attendance-check' },
        { name: 'EasyCardActivity', route: '/easy-card' },
        { name: 'EasyCardPinActivity', route: '/easy-card/pin' },
        { name: 'EasyCardPinLockedModal', route: '/easy-card/pin/locked' },
        { name: 'EasyCardManageBottomSheet', route: '/easy-cards/:cardId' },
        { name: 'EasyCardNameBottomSheet', route: '/easy-cards/:cardId/name' },
        { name: 'EasyCardDeleteModal', route: '/easy-cards/:cardId/delete' },
        { name: 'EasyCarRegistrationActivity', route: '/easy-card/kicc/callback' },
        { name: 'EasyCardIdentifyFailActivity', route: '/identify/update-pin/failed' },
        { name: 'EasyCardIdentifySuccessActivity', route: '/identify/update-pin/done' },
        { name: 'WithdrawManualActivity', route: '/withdraw-manual' },
        { name: 'TierBenefitsBottomSheet', route: '/tier/benefits' },
        { name: 'TierHistoryActivity', route: '/tier/history' },
        { name: 'TierCalculatedDateBottomSheet', route: '/tier/calculated-cycles' },
        { name: 'NotReadyModal', route: '/not-ready' },
        { name: 'DeepLinkActivity', route: '/deep-link' },
    ],
});
